import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["versions"],
  _excluded2 = ["results"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
import { SheetItem } from '../models';
import PermissionItem from '../models/PermissionItem';
import { CommonUtil } from '../utils';
import { CANCEL_KEYS, SHEETS_CONTAINER_TYPES } from '../utils/consts';
/**
 * `Service` The sheet service, is used to creed sheet related data.
 */
var Sheets = /*#__PURE__*/function (_Base) {
  /**
   * Create the sheets service instance.
   *
   * @param sdk - the SDK instance
   */
  function Sheets(sdk) {
    _classCallCheck(this, Sheets);
    return _callSuper(this, Sheets, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(Sheets, _Base);
  return _createClass(Sheets, [{
    key: "getSheetsContainer",
    value: (
    /**
     * Get sheets container
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/f1ec0915913a7-get-a-container
     *
     * @param projectId - the project id
     * @param params - the query parameters, `sheetContainerType` can be omitted and will fallback to default value 'Build'
     * @param config - conf Configurable object for overwrite request parameters
     * @returns The sheet container object
     */
    function () {
      var _getSheetsContainer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, params, config) {
        var query, url, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/sheet-containers/".concat(projectId).concat(query);
              _context.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context.sent;
              return _context.abrupt("return", res.data);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getSheetsContainer(_x, _x2, _x3) {
        return _getSheetsContainer.apply(this, arguments);
      }
      return getSheetsContainer;
    }()
    /**
     * enable project collections
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/49eeee7649bcc-enable-collections
     *
     * @param projectId - the project uuid
     * @param params - query parameters including `sheetContainerType`
     * @param config - conf Configurable object for overwrite request parameters
     */
    )
  }, {
    key: "enableCollections",
    value: (function () {
      var _enableCollections = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, params, config) {
        var query, url;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/collections:enable").concat(query);
              _context2.next = 4;
              return this.HttpService.dmV3.post(url, undefined, config);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function enableCollections(_x4, _x5, _x6) {
        return _enableCollections.apply(this, arguments);
      }
      return enableCollections;
    }()
    /**
     * Get sheets collection list
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/e95ce15dc48da-list-collections
     *
     * @param projectId - the project uuid
     * @param params - query parameters including `includeSheetsCount`, `detectDefaultCollectionEmpty`, `limit`, `offset` and `sheetContainerType`
     * @param config - conf Configurable object for overwrite request parameters
     * @returns a promise with details collection list
     */
    )
  }, {
    key: "getCollections",
    value: (function () {
      var _getCollections = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, params, config) {
        var query, url, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/collections").concat(query);
              _context3.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context3.sent;
              return _context3.abrupt("return", res.data);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getCollections(_x7, _x8, _x9) {
        return _getCollections.apply(this, arguments);
      }
      return getCollections;
    }()
    /**
     * Create sheets collection
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/c2e8bbda53e96-create-a-collection
     *
     * @param projectId - the project uuid
     * @param payload - request payload including `name`
     * @param params - query parameters including `sheetContainerType`
     * @param config - conf Configurable object for overwrite request parameters
     * @returns a promise with the created collection
     */
    )
  }, {
    key: "createCollection",
    value: (function () {
      var _createCollection = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId, payload, params, config) {
        var query, url, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/collections").concat(query);
              _context4.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              res = _context4.sent;
              return _context4.abrupt("return", res.data);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function createCollection(_x10, _x11, _x12, _x13) {
        return _createCollection.apply(this, arguments);
      }
      return createCollection;
    }()
    /**
     * Get sheets collection
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/be84ebbb6aa81-get-a-collection
     *
     * @param projectId - the project uuid
     * @param collectionId - the collection uid
     * @param params - query parameters including sheetContainerType
     * @param config - conf Configurable object for overwrite request parameters
     * @returns a promise with the collection details
     */
    )
  }, {
    key: "getCollection",
    value: (function () {
      var _getCollection = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(projectId, collectionId, params, config) {
        var query, url, res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/collections/").concat(collectionId).concat(query);
              _context5.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context5.sent;
              return _context5.abrupt("return", res.data);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getCollection(_x14, _x15, _x16, _x17) {
        return _getCollection.apply(this, arguments);
      }
      return getCollection;
    }()
    /**
     * Rename sheets collection
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/9e28bc3d4bf29-rename-a-collection
     *
     * @param projectId - the project uuid
     * @param collectionId - the collection uid
     * @param payload - with including name
     * @param params - query parameters with including sheetContainerType
     * @param config - conf Configurable object for overwrite request parameters
     * @returns a promise with the updated collection
     */
    )
  }, {
    key: "renameCollection",
    value: (function () {
      var _renameCollection = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(projectId, collectionId, payload, params, config) {
        var query, url, res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/collections/").concat(collectionId).concat(query);
              _context6.next = 4;
              return this.HttpService.dmV3.patch(url, payload, config);
            case 4:
              res = _context6.sent;
              return _context6.abrupt("return", res.data);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function renameCollection(_x18, _x19, _x20, _x21, _x22) {
        return _renameCollection.apply(this, arguments);
      }
      return renameCollection;
    }()
    /**
     * Delete sheets collection
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/4406e0469befe-delete-a-collection
     *
     * @param projectId - the project uuid
     * @param collectionId - the collection uid
     * @param params - query parameters with including sheetContainerType
     * @param config - conf Configurable object for overwrite request parameters
     */
    )
  }, {
    key: "deleteCollection",
    value: (function () {
      var _deleteCollection = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(projectId, collectionId, params, config) {
        var query, url;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/collections/").concat(collectionId).concat(query);
              _context7.next = 4;
              return this.HttpService.dmV3["delete"](url, config);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function deleteCollection(_x23, _x24, _x25, _x26) {
        return _deleteCollection.apply(this, arguments);
      }
      return deleteCollection;
    }()
    /**
     * Get the sheets.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/fb16e4c1c9eb1-list-sheets
     *
     * @param projectId - the project uuid
     * @param params - query parameters including
     *                                    sheetContainerType
     *                                    filter[setId],
     *                                    filter[tag],
     *                                    filter[disciplines],
     *                                    limit,
     *                                    offset,
     *                                    searchText,
     *                                    fields,
     *                                    currentOnly,
     *                                    includeCurrentSetCount,
     *                                    isDeleted, // True to return the deleted sheets only
     *                                    sort       // Only valid when isDeleted = true, default value 'deletedAt desc, natSortName asc'
     * @param conf - Configurable object for overwrite request parameters.
     * @returns a promise that including `pagination`, `currentSetCount` and `sheets`
     */
    )
  }, {
    key: "getSheets",
    value: (function () {
      var _getSheets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(projectId, params, conf) {
        var _this = this;
        var config, query, url, response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              config = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this.loadSheetsCancelToken;
                },
                setter: function setter(token) {
                  return _this.loadSheetsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this.loadSheetsCancelToken = undefined;
                }
              }), conf);
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params, {
                locale: this.Config.locale
              }), {
                addQueryPrefix: true,
                arrayFormat: 'brackets'
              });
              url = "/projects/".concat(projectId, "/sheets").concat(query);
              _context8.next = 5;
              return this.HttpService.dmV3.get(url, config);
            case 5:
              response = _context8.sent;
              return _context8.abrupt("return", {
                pagination: response.data.pagination || {},
                currentSetCount: response.data.currentSetCount || 0,
                sheets: (response.data.results || []).map(SheetItem.parseV3)
              });
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getSheets(_x27, _x28, _x29) {
        return _getSheets.apply(this, arguments);
      }
      return getSheets;
    }()
    /**
     * Get the version count of sheet.
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/976d945d464ea-get-sheets-statistic
     *
     * @param projectId - the project uuid
     * @param payload - array of sheets ids
     * @param params - query parameters including `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that shape of \{ [sheetId]: \{ count \} \}
     */
    )
  }, {
    key: "getSheetsStats",
    value: (function () {
      var _getSheetsStats = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(projectId, payload, params, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheets:get-stats").concat(query);
              _context9.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              response = _context9.sent;
              return _context9.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getSheetsStats(_x30, _x31, _x32, _x33) {
        return _getSheetsStats.apply(this, arguments);
      }
      return getSheetsStats;
    }()
    /**
     * Get the sheets ids under given condition.
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/82778516acb31-get-sheet-ids
     *
     * @param projectId - the project uuid
     * @param params - query parameters including `sheetContainerType`, `currentOnly`, `filter[setId]`, `filter[tag]`, `searchText`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that includes list of sheets ids
     */
    )
  }, {
    key: "getSheetsIds",
    value: (function () {
      var _getSheetsIds = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(projectId, params, config) {
        var _this2 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.loadSheetsIdsCancelToken;
                },
                setter: function setter(token) {
                  return _this2.loadSheetsIdsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.loadSheetsIdsCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true,
                arrayFormat: 'brackets'
              });
              url = "/projects/".concat(projectId, "/sheet-ids").concat(query);
              _context10.next = 5;
              return this.HttpService.dmV3.get(url, conf);
            case 5:
              response = _context10.sent;
              return _context10.abrupt("return", response.data || []);
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getSheetsIds(_x34, _x35, _x36) {
        return _getSheetsIds.apply(this, arguments);
      }
      return getSheetsIds;
    }()
    /**
     * Get the sheets project related tag labels.
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/a6f8da4b1b8e0-list-project-tags
     *
     * @param projectId - the project uuid
     * @param params - query parameters including `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise including results of tags
     */
    )
  }, {
    key: "getTags",
    value: (function () {
      var _getTags = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(projectId, params, config) {
        var _this3 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this3.loadTagsCancelToken;
                },
                setter: function setter(token) {
                  return _this3.loadTagsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this3.loadTagsCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/tags").concat(query);
              _context11.next = 5;
              return this.HttpService.dmV3.get(url, conf);
            case 5:
              response = _context11.sent;
              return _context11.abrupt("return", response.data || {});
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getTags(_x37, _x38, _x39) {
        return _getTags.apply(this, arguments);
      }
      return getTags;
    }()
    /**
     * delete sheets
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/3d78a354d063a-delete-sheets
     *
     * @param projectId - the project uuid
     * @param payload - array of sheet ids
     * @param params - query parameters including `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with an object
     */
    )
  }, {
    key: "deleteSheets",
    value: (function () {
      var _deleteSheets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(projectId, payload, params, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheets:batch-delete").concat(query);
              _context12.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              response = _context12.sent;
              return _context12.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function deleteSheets(_x40, _x41, _x42, _x43) {
        return _deleteSheets.apply(this, arguments);
      }
      return deleteSheets;
    }()
    /**
     * get sheets intersection
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/378845e65c99f-get-sheets-intersection
     *
     * @param projectId - the project uuid
     * @param payload - array of sheet ids
     * @param params - query parameters including `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with list of tags attached
     */
    )
  }, {
    key: "getSheetsIntersect",
    value: (function () {
      var _getSheetsIntersect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(projectId, payload, params, config) {
        var _this4 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this4.loadIntersectionCancelToken;
                },
                setter: function setter(token) {
                  return _this4.loadIntersectionCancelToken = token;
                },
                clearer: function clearer() {
                  return _this4.loadIntersectionCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheets:get-intersect").concat(query);
              _context13.next = 5;
              return this.HttpService.dmV3.post(url, payload, conf);
            case 5:
              response = _context13.sent;
              return _context13.abrupt("return", response.data || {});
            case 7:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function getSheetsIntersect(_x44, _x45, _x46, _x47) {
        return _getSheetsIntersect.apply(this, arguments);
      }
      return getSheetsIntersect;
    }()
    /**
     * update sheets
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/95088df2b589a-update-sheets
     *
     * @param projectId - the project uuid
     * @param payload - contains ids of updated sheets and the updates, including
     *                            ids,
     *                            updates: name, description, versionSetId, addTags, removeTags
     * @param params - query parameters including `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with list of ids of updated sheets in results
     */
    )
  }, {
    key: "updateSheets",
    value: (function () {
      var _updateSheets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(projectId, payload, params, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheets:batch-update").concat(query);
              _context14.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              response = _context14.sent;
              return _context14.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function updateSheets(_x48, _x49, _x50, _x51) {
        return _updateSheets.apply(this, arguments);
      }
      return updateSheets;
    }()
    /**
     * get sheets permission for the user
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/97fd60eab976c-get-sheet-permissions-for-users
     *
     * @param projectId - the project uuid
     * @param userId - the user id
     * @param params - The query parameters with `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with user permission
     */
    )
  }, {
    key: "getSheetsPermission",
    value: (function () {
      var _getSheetsPermission = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(projectId, userId, params, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-permissions/users/").concat(userId).concat(query);
              _context15.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              response = _context15.sent;
              return _context15.abrupt("return", PermissionItem.parseV3(response.data));
            case 6:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function getSheetsPermission(_x52, _x53, _x54, _x55) {
        return _getSheetsPermission.apply(this, arguments);
      }
      return getSheetsPermission;
    }()
    /**
     * get sheets permission list
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/1583b0b75985a-get-sheet-permissions
     *
     * @param projectId - the project uuid
     * @param params - The query parameters including sheetContainerType
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with list of permission item
     */
    )
  }, {
    key: "getSheetsPermissions",
    value: (function () {
      var _getSheetsPermissions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(projectId, params, config) {
        var _this5 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this5.loadPermissionsCancelToken;
                },
                setter: function setter(token) {
                  return _this5.loadPermissionsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this5.loadPermissionsCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-permissions").concat(query);
              _context16.next = 5;
              return this.HttpService.dmV3.get(url, conf);
            case 5:
              response = _context16.sent;
              return _context16.abrupt("return", {
                permissions: (response.data.results || []).map(PermissionItem.parseV3),
                errors: response.data.errors
              });
            case 7:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function getSheetsPermissions(_x56, _x57, _x58) {
        return _getSheetsPermissions.apply(this, arguments);
      }
      return getSheetsPermissions;
    }()
    /**
     * batch-update sheets permissions
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/d9126c47f3e89-batch-update-permissions
     *
     * @param projectId - the project uuid
     * @param payload -, include permissions, permission is shape of
     *                            subjectId: The HQ id of subject
     *                            subjectType: The type of subject. Could be USER, COMPANY, ROLE or GROUP(everyone only)
     *                            actions: The permission actions array. E.g. ["VIEW","DOWNLOAD","COLLABORATE","PUBLISH_MARKUP","PUBLISH","EDIT","CONTROL"]
     * @param params - The query parameters including `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with list of tags attached, shape of \{ tags \}
     */
    )
  }, {
    key: "updateSheetsPermissions",
    value: (function () {
      var _updateSheetsPermissions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(projectId, payload, params, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-permissions:batch-update").concat(query);
              _context17.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              response = _context17.sent;
              return _context17.abrupt("return", {
                permissions: (response.data.results || []).map(PermissionItem.parseV3),
                errors: response.data.errors
              });
            case 6:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function updateSheetsPermissions(_x59, _x60, _x61, _x62) {
        return _updateSheetsPermissions.apply(this, arguments);
      }
      return updateSheetsPermissions;
    }()
    /**
     * batch-delete sheets permissions
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/11703cb8b3bf0-batch-delete-permissions
     *
     * @param projectId - the project uuid
     * @param payload -, include permissions, permission is shape of
     *                            subjectId,
     *                            subjectType
     * @param params - The query parameters including `sheetContainerType`
     * @param config -  Configurable object for overwrite request parameters.
     * @returns a promise with list of tags attached, shape of \{ tags \}
     */
    )
  }, {
    key: "deleteSheetsPermissions",
    value: (function () {
      var _deleteSheetsPermissions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18(projectId, payload, params, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-permissions:batch-delete").concat(query);
              _context18.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              response = _context18.sent;
              return _context18.abrupt("return", {
                permissions: (response.data.results || []).map(PermissionItem.parseV3),
                errors: response.data.errors
              });
            case 6:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function deleteSheetsPermissions(_x63, _x64, _x65, _x66) {
        return _deleteSheetsPermissions.apply(this, arguments);
      }
      return deleteSheetsPermissions;
    }()
    /**
     * get sheets histories by sheet names.
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/5841c489c91cd-get-sheet-histories-by-name
     *
     * @param projectId - the project uuid
     * @param params - The query parameters
     *                        names: sheet names
     *                        fields: specify fields in the sheets histories. All fields if not specified.
     *                        collectionId: target collection id.
     *                        sheetContainerType: "Build" or "QTO"
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that includes an object, the keys of the object are sheet-names, the values of the object are sheets list with the sheet-name
     */
    )
  }, {
    key: "getSheetsHistoriesByNames",
    value: (function () {
      var _getSheetsHistoriesByNames = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19(projectId, params, config) {
        var _this6 = this;
        var conf, query, url, response, sheetsHistories;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this6.loadSheetsHistoriesCancelToken;
                },
                setter: function setter(token) {
                  return _this6.loadSheetsHistoriesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this6.loadSheetsHistoriesCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-histories").concat(query);
              _context19.next = 5;
              return this.HttpService.dmV3.get(url, conf);
            case 5:
              response = _context19.sent;
              sheetsHistories = response.data || {};
              return _context19.abrupt("return", Object.keys(sheetsHistories).reduce(function (parsedSheetsHistories, key) {
                parsedSheetsHistories[key] = sheetsHistories[key].map(SheetItem.parseV3);
                return parsedSheetsHistories;
              }, {}));
            case 8:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function getSheetsHistoriesByNames(_x67, _x68, _x69) {
        return _getSheetsHistoriesByNames.apply(this, arguments);
      }
      return getSheetsHistoriesByNames;
    }()
    /**
     * batch-get multiple sheets by ids
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/0e6a1516566c3-get-sheets-by-ids
     *
     * @param projectId - the project uuid
     * @param payload - list of sheets ids
     * @param params - The query parameters including `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with list of sheets
     */
    )
  }, {
    key: "getSheetsByIds",
    value: (function () {
      var _getSheetsByIds = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20(projectId, payload, params, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              query = QS.stringify(_extends({
                locale: this.Config.locale,
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheets:batch-get").concat(query);
              _context20.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              response = _context20.sent;
              return _context20.abrupt("return", (response.data || []).map(SheetItem.parseV3));
            case 6:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function getSheetsByIds(_x70, _x71, _x72, _x73) {
        return _getSheetsByIds.apply(this, arguments);
      }
      return getSheetsByIds;
    }()
    /**
     * batch-get multiple sheets histories
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/c748b66cd556d-batch-get-sheet-histories
     *
     * @param projectId - the project uuid
     * @param payload - payload data including ids: array, names: array, versionLimit: number
     *                  ids: history ids, only valid if names does not exist.
     *                  names: history names, only valid if ids does not exist.
     *                  versionLimit: Maximum number of versions included in a history. Include all versions by default.
     *                  collectionId: Filter by sheet collection. When not provided, only results in default collection would be returned.
     * @param params - The query parameters including `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with list of sheet histories with `id`, `name`, `versions`
     */
    )
  }, {
    key: "getSheetsHistories",
    value: (function () {
      var _getSheetsHistories = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee21(projectId, payload, params, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-histories:batch-get").concat(query);
              _context21.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              response = _context21.sent;
              return _context21.abrupt("return", (response.data || []).map(function (_ref) {
                var versions = _ref.versions,
                  rest = _objectWithoutProperties(_ref, _excluded);
                return _extends({}, rest, {
                  versions: versions.map(SheetItem.parseV3)
                });
              }));
            case 6:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function getSheetsHistories(_x74, _x75, _x76, _x77) {
        return _getSheetsHistories.apply(this, arguments);
      }
      return getSheetsHistories;
    }()
    /**
     * Move all version sheets by sheet history ids
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/5f88c0b7ea6f5-batch-move-sheet-histories
     *
     * @param projectId - The project id
     * @param payload - request with targetCollectionId, ids, ignoreIssuanceDate
     * @param params - The query parameters including `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters
     *
     * @returns a promise with array of move ids
     */
    )
  }, {
    key: "moveSheetHistories",
    value: (function () {
      var _moveSheetHistories = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee22(projectId, payload, params, config) {
        var query, url, res;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-histories:batch-move").concat(query);
              _context22.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              res = _context22.sent;
              return _context22.abrupt("return", res.data);
            case 6:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function moveSheetHistories(_x78, _x79, _x80, _x81) {
        return _moveSheetHistories.apply(this, arguments);
      }
      return moveSheetHistories;
    }()
    /**
     * Get move sheets history status by moveIds
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/b0ee2dbd8e090-get-move-status
     *
     * @param projectId - The project id
     * @param moveIds - The move ids which from moveSheetHistories APIs
     * @param params - The query parameters including `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters
     *
     * @returns a promise with moving status data
     */
    )
  }, {
    key: "getMoveStatus",
    value: (function () {
      var _getMoveStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee23(projectId, moveIds, params, config) {
        var query, url, res;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-histories:get-move-states").concat(query);
              _context23.next = 4;
              return this.HttpService.dmV3.post(url, moveIds, config);
            case 4:
              res = _context23.sent;
              return _context23.abrupt("return", res.data);
            case 6:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function getMoveStatus(_x82, _x83, _x84, _x85) {
        return _getMoveStatus.apply(this, arguments);
      }
      return getMoveStatus;
    }()
    /**
     * Get sheets upload statistics
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/8e917ecb14fc5-get-statistics-of-upload-jobs
     *
     * @param projectId - the project uuid
     * @param params - The query parameters including `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters.
     * @returns statistics data
     */
    )
  }, {
    key: "getSheetsUploadStatistic",
    value: (function () {
      var _getSheetsUploadStatistic = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee24(projectId, params, config) {
        var query, url, res;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheets/uploads/statistics").concat(query);
              _context24.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context24.sent;
              return _context24.abrupt("return", res.data || {});
            case 6:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function getSheetsUploadStatistic(_x86, _x87, _x88) {
        return _getSheetsUploadStatistic.apply(this, arguments);
      }
      return getSheetsUploadStatistic;
    }()
    /**
     * Get Published Document Information
     * https://platform.stoplight.autodesk.com/docs/docs-cp/3bb656523a3c8-private-get-published-document-information
     *
     * @param projectId - the project uuid
     * @param ids - list of document/version ids
     * @param config - Configurable object for overwrite request parameters
     * @returns detail results or errors
     */
    )
  }, {
    key: "getPublishedDocumentInfo",
    value: (function () {
      var _getPublishedDocumentInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee25(projectId, ids, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              url = "/projects/".concat(projectId, "/published-document-info:batch-get");
              _context25.next = 3;
              return this.HttpService.dmV3.post(url, {
                ids: ids
              }, config);
            case 3:
              response = _context25.sent;
              return _context25.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function getPublishedDocumentInfo(_x89, _x90, _x91) {
        return _getPublishedDocumentInfo.apply(this, arguments);
      }
      return getPublishedDocumentInfo;
    }()
    /**
     * Get the sheets count
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/fb16e4c1c9eb1-list-sheets
     *
     * @param projectId - the project uuid
     * @param params - query parameters
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves a number
     */
    )
  }, {
    key: "getSheetsCount",
    value: (function () {
      var _getSheetsCount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee26(projectId, params, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params, {
                offset: 0,
                limit: 1,
                includeCurrentSetCount: false
              }), {
                addQueryPrefix: true,
                arrayFormat: 'brackets'
              });
              url = "/projects/".concat(projectId, "/sheets").concat(query);
              _context26.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              response = _context26.sent;
              return _context26.abrupt("return", CommonUtil.getValue(response, 'data.pagination.totalResults'));
            case 6:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function getSheetsCount(_x92, _x93, _x94) {
        return _getSheetsCount.apply(this, arguments);
      }
      return getSheetsCount;
    }()
    /**
     * Count all sheets without disciplines in a project
     * This function is used when there is no filter or searchText
     * When there is a filter or searchText, should use another function: getSheetsCount
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/2939758d65c45-count-all-unordered-sheets
     *
     * @param projectId - the project uuid
     * @param params - The query parameters at url including `sheetContainerType` or `collectionId`
     * @param config - Configurable object for overwrite request parameters
     * @returns a promise that resolves a number
     */
    )
  }, {
    key: "getNoDisciplineCount",
    value: (function () {
      var _getNoDisciplineCount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee27(projectId, params, config) {
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              conf = _extends({
                'axios-retry': {
                  retryCondition: function retryCondition() {
                    return true;
                  }
                }
              }, config);
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-disciplines:countNoDiscipline").concat(query);
              _context27.next = 5;
              return this.HttpService.dmV3.post(url, {}, conf);
            case 5:
              response = _context27.sent;
              return _context27.abrupt("return", (response.data || {}).count);
            case 7:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function getNoDisciplineCount(_x95, _x96, _x97) {
        return _getNoDisciplineCount.apply(this, arguments);
      }
      return getNoDisciplineCount;
    }()
    /**
     * Check whether the given sheets are restorable
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/6f6ddd4d8152e-check-restorability
     *
     * @param projectId - the project uuid
     * @param ids - list of sheet ids
     * @param params - query parameters including `sheetContainerType`
     * @param config - Configurable object for overwrite request parameters
     * @returns a promise with sheets ids.
     */
    )
  }, {
    key: "getSheetsRestorable",
    value: (function () {
      var _getSheetsRestorable = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee28(projectId, ids, params, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheets:restorable").concat(query);
              _context28.next = 4;
              return this.HttpService.dmV3.post(url, {
                ids: ids
              }, config);
            case 4:
              response = _context28.sent;
              return _context28.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function getSheetsRestorable(_x98, _x99, _x100, _x101) {
        return _getSheetsRestorable.apply(this, arguments);
      }
      return getSheetsRestorable;
    }()
    /**
     * restore sheets
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/e33094f3e4303-restore-sheets
     *
     * @param projectId - is the project id
     * @param ids - are the sheets ids
     * @param params - query parameters including sheetContainerType
     * @param config - Configurable object for overwrite request parameters
     * @returns a promise with sheets ids
     */
    )
  }, {
    key: "restoreSheets",
    value: (function () {
      var _restoreSheets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee29(projectId, ids, params, config) {
        var query, response;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              _context29.next = 3;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/sheets:batch-restore").concat(query), {
                ids: ids
              }, config);
            case 3:
              response = _context29.sent;
              return _context29.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function restoreSheets(_x102, _x103, _x104, _x105) {
        return _restoreSheets.apply(this, arguments);
      }
      return restoreSheets;
    }()
    /**
     * Search sheets through forge search service
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/396346530be27-search-sheets
     *
     * @param projectId - The project uuid
     * @param payload - The search payload with the shape of
     *    searchText: <string> the search keyword
     *    pageNumber: <Number> the current page
     *    includeContent: <Boolean> whether to search context
     *    deleted: <Boolean> whether to search deleted sheets
     *    filters: <Object> The filter object, available keys:
     *                      `tags`, `dateModified`, `updatedBy`, `deletedAt`, `deletedBy`, `versionSetId`, `collectionId`, `disciplineDesignator` and `currentOnly`
     *    sorters: <Array> The sorting field with shape of `field` and `order`: `acs/desc`, available fields:
     *                      `natName`, `name`, `title`, `tagsCount`, `disciplineOrder`, `disciplineDesignator`, `collectionName`, `setName`, `issuanceDate`, `dateModified`
     *                      `updatedByName`, `deletedAt` and `deletedByName`
     * @param params - The search query parameter with `containerType` and `locale`
     * @param config - Configurable object for overwrite request parameters
     */
    )
  }, {
    key: "searchSheets",
    value: (function () {
      var _searchSheets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee30(projectId, payload, params, config) {
        var _this7 = this;
        var conf, query, response, _response$data, results, rest;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this7.searchSheetsCancelToken;
                },
                setter: function setter(token) {
                  return _this7.searchSheetsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this7.searchSheetsCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                containerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params, {
                locale: (params === null || params === void 0 ? void 0 : params.locale) || this.Config.locale
              }), {
                addQueryPrefix: true
              });
              _context30.next = 4;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/sheets:search").concat(query), payload, conf);
            case 4:
              response = _context30.sent;
              _response$data = response.data, results = _response$data.results, rest = _objectWithoutProperties(_response$data, _excluded2);
              return _context30.abrupt("return", _extends({}, rest, {
                results: (results || []).map(SheetItem.parseV3)
              }));
            case 7:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function searchSheets(_x106, _x107, _x108, _x109) {
        return _searchSheets.apply(this, arguments);
      }
      return searchSheets;
    }()
    /**
     * Get filter options for given filter category from forge search service
     *
     * @param projectId - The project uuid
     * @param payload - The search parameters
     *            deleted: <Boolean> whether to search deleted sheets
     *            numberOfValues: <Number> Control the number of options returned for each category
     *            categoryKeys: <Array> Config category keys to fetch filter options, available keys:
     *                          `disciplineDesignator`, `versionSetId`, `tags`, `updatedBy` and `deletedBy`
     *            filterText: <string> The keyword used to filter given category options
     *            filters: <Object> The filter object, available keys: `collectionId`.
     * @param params - The search query parameter with the shape of
     *                          containerType, // Default to `Build`
     * @param config - Configurable object for overwrite request parameters.
     */
    )
  }, {
    key: "getSearchCategories",
    value: (function () {
      var _getSearchCategories = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee31(projectId, payload, params, config) {
        var _this8 = this;
        var conf, query, response;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this8.categoriesCancelToken;
                },
                setter: function setter(token) {
                  return _this8.categoriesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this8.categoriesCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                containerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              _context31.next = 4;
              return this.HttpService.dmV3.post("/projects/".concat(projectId, "/sheets:filter-categories").concat(query), payload, conf);
            case 4:
              response = _context31.sent;
              return _context31.abrupt("return", response.data);
            case 6:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function getSearchCategories(_x110, _x111, _x112, _x113) {
        return _getSearchCategories.apply(this, arguments);
      }
      return getSearchCategories;
    }()
    /**
     * Get user saved sheet queries
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/bd69a70080179-get-user-related-queries
     *
     * @param projectId - The project uuid.
     * @param params - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "getSheetQueries",
    value: (function () {
      var _getSheetQueries = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee32(projectId, params, config) {
        var _this9 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this9.getSheetQueriesCancelToken;
                },
                setter: function setter(token) {
                  return _this9.getSheetQueriesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this9.getSheetQueriesCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                containerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-queries").concat(query);
              _context32.next = 5;
              return this.HttpService.dmV3.get(url, conf);
            case 5:
              response = _context32.sent;
              return _context32.abrupt("return", response.data);
            case 7:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
      function getSheetQueries(_x114, _x115, _x116) {
        return _getSheetQueries.apply(this, arguments);
      }
      return getSheetQueries;
    }()
    /**
     * Get sheet query with given id
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/f31c756fa9ba2-get-a-user-query-by-id
     *
     * @param projectId - The project uuid.
     * @param id - The user query uuid.
     * @param params - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "getSheetQuery",
    value: (function () {
      var _getSheetQuery = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee33(projectId, id, params, config) {
        var _this10 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this10.getSheetQueryCancelToken;
                },
                setter: function setter(token) {
                  return _this10.getSheetQueryCancelToken = token;
                },
                clearer: function clearer() {
                  return _this10.getSheetQueryCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                containerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-queries/").concat(id).concat(query);
              _context33.next = 5;
              return this.HttpService.dmV3.get(url, conf);
            case 5:
              response = _context33.sent;
              return _context33.abrupt("return", response.data);
            case 7:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function getSheetQuery(_x117, _x118, _x119, _x120) {
        return _getSheetQuery.apply(this, arguments);
      }
      return getSheetQuery;
    }()
    /**
     * Create a new sheet query
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/fe34deb62e428-create-a-new-user-query
     *
     * @param projectId - The project uuid.
     * @param params - The request parameters refer to stoplight.
     * @param payload - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "createSheetQuery",
    value: (function () {
      var _createSheetQuery = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee34(projectId) {
        var _this11 = this;
        var params,
          payload,
          config,
          conf,
          query,
          url,
          response,
          _args34 = arguments;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              params = _args34.length > 1 && _args34[1] !== undefined ? _args34[1] : {};
              payload = _args34.length > 2 ? _args34[2] : undefined;
              config = _args34.length > 3 ? _args34[3] : undefined;
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this11.createSheetQueryCancelToken;
                },
                setter: function setter(token) {
                  return _this11.createSheetQueryCancelToken = token;
                },
                clearer: function clearer() {
                  return _this11.createSheetQueryCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                containerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-queries").concat(query);
              _context34.next = 8;
              return this.HttpService.dmV3.post(url, payload, conf);
            case 8:
              response = _context34.sent;
              return _context34.abrupt("return", response.data);
            case 10:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
      function createSheetQuery(_x121) {
        return _createSheetQuery.apply(this, arguments);
      }
      return createSheetQuery;
    }()
    /**
     * Update sheet query
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/1b98c6db2e24a-update-query-context
     *
     * @param projectId - The project uuid.
     * @param id - The user query uuid.
     * @param params - The request parameters refer to stoplight.
     * @param payload - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "updateSheetQuery",
    value: (function () {
      var _updateSheetQuery = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee35(projectId, id) {
        var _this12 = this;
        var params,
          payload,
          config,
          conf,
          query,
          url,
          response,
          _args35 = arguments;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              params = _args35.length > 2 && _args35[2] !== undefined ? _args35[2] : {};
              payload = _args35.length > 3 ? _args35[3] : undefined;
              config = _args35.length > 4 ? _args35[4] : undefined;
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this12.updateSheetQueryCancelToken;
                },
                setter: function setter(token) {
                  return _this12.updateSheetQueryCancelToken = token;
                },
                clearer: function clearer() {
                  return _this12.updateSheetQueryCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                containerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-queries/").concat(id).concat(query);
              _context35.next = 8;
              return this.HttpService.dmV3.patch(url, payload, conf);
            case 8:
              response = _context35.sent;
              return _context35.abrupt("return", response.data);
            case 10:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
      function updateSheetQuery(_x122, _x123) {
        return _updateSheetQuery.apply(this, arguments);
      }
      return updateSheetQuery;
    }()
    /**
     * Delete user query with given id
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/b89340265d79c-delete-user-query-by-id
     *
     * @param projectId - The project uuid.
     * @param id - The user query uuid.
     * @param params - The request parameters refer to stoplight.
     * @param config - Configurable object to overwrite request parameters.
     * @returns with the response data refer to stoplight.
     */
    )
  }, {
    key: "deleteSheetQuery",
    value: (function () {
      var _deleteSheetQuery = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee36(projectId, id, params, config) {
        var _this13 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this13.deleteSheetQueryCancelToken;
                },
                setter: function setter(token) {
                  return _this13.deleteSheetQueryCancelToken = token;
                },
                clearer: function clearer() {
                  return _this13.deleteSheetQueryCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                containerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-queries/").concat(id).concat(query);
              _context36.next = 5;
              return this.HttpService.dmV3["delete"](url, conf);
            case 5:
              response = _context36.sent;
              return _context36.abrupt("return", response.data);
            case 7:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this);
      }));
      function deleteSheetQuery(_x124, _x125, _x126, _x127) {
        return _deleteSheetQuery.apply(this, arguments);
      }
      return deleteSheetQuery;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Sheets';
    }
  }]);
}(Base);
export default Sheets;